export const reCaptcha = (success: (reCaptchaToken: string) => void, error: (error: any) => void) => {
  if ((window as any)?.grecaptcha) {
    (window as any).grecaptcha.ready(() => {
      (window as any).grecaptcha
        .execute('6Leh8AQfAAAAAEPSCKOFfX053-T22KKBqtd5YB0U', { action: 'submit' })
        .then(success)
        .catch((err: any) => {
          console.error('reCaptcha', err);

          error({ message: 'reCaptcha error' });
        });
    });
  } else {
    error({ message: 'reCaptcha not loaded' });
  }
};
